// extracted by mini-css-extract-plugin
export default {"backdropContainer":"watchlist_backdropContainer__rEcnT","container":"watchlist_container__MuzSp","warning":"watchlist_warning__SRdIT"};